import type { ToastRootProps } from 'radix-vue'
import type { HTMLAttributes } from 'vue'

import { type VariantProps, cva } from 'class-variance-authority'

export { toast, useToast } from './use-toast'

export const toastVariants = cva(
	'data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full group pointer-events-auto relative flex w-full items-center justify-between space-x-2 overflow-hidden rounded-md border p-4 pr-6 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none',
	{
		variants: {
			variant: {
				default: 'bg-background text-foreground border',
				destructive:
                    'destructive border-destructive bg-destructive/5 text-destructive group',
				successful: 'successful border-successful bg-successful/5 text-successful group',
				informative: 'informative border-informative bg-informative/5 text-informative group',
			},
		},
		defaultVariants: {
			variant: 'default',
		},
	},
)

type ToastVariants = VariantProps<typeof toastVariants>

export interface ToastProps extends ToastRootProps {
	class?: HTMLAttributes['class']
	variant?: ToastVariants['variant']
	onOpenChange?: ((value: boolean) => void) | undefined
}
